import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Location from '../geom/Location';
import Coordinate from '../geom/Coordinate';
import Node from './Node';
import ArrayList from '../../../../java/util/ArrayList';
import TreeMap from '../../../../java/util/TreeMap';
var NodeMap = /*#__PURE__*/function () {
  function NodeMap() {
    _classCallCheck(this, NodeMap);
    NodeMap.constructor_.apply(this, arguments);
  }
  _createClass(NodeMap, [{
    key: "find",
    value: function find(coord) {
      return this.nodeMap.get(coord);
    }
  }, {
    key: "addNode",
    value: function addNode() {
      if (arguments[0] instanceof Coordinate) {
        var coord = arguments[0];
        var node = this.nodeMap.get(coord);
        if (node === null) {
          node = this.nodeFact.createNode(coord);
          this.nodeMap.put(coord, node);
        }
        return node;
      } else if (arguments[0] instanceof Node) {
        var n = arguments[0];
        var _node = this.nodeMap.get(n.getCoordinate());
        if (_node === null) {
          this.nodeMap.put(n.getCoordinate(), n);
          return n;
        }
        _node.mergeLabel(n);
        return _node;
      }
    }
  }, {
    key: "print",
    value: function print(out) {
      for (var it = this.iterator(); it.hasNext();) {
        var n = it.next();
        n.print(out);
      }
    }
  }, {
    key: "iterator",
    value: function iterator() {
      return this.nodeMap.values().iterator();
    }
  }, {
    key: "values",
    value: function values() {
      return this.nodeMap.values();
    }
  }, {
    key: "getBoundaryNodes",
    value: function getBoundaryNodes(geomIndex) {
      var bdyNodes = new ArrayList();
      for (var i = this.iterator(); i.hasNext();) {
        var node = i.next();
        if (node.getLabel().getLocation(geomIndex) === Location.BOUNDARY) bdyNodes.add(node);
      }
      return bdyNodes;
    }
  }, {
    key: "add",
    value: function add(e) {
      var p = e.getCoordinate();
      var n = this.addNode(p);
      n.add(e);
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this.nodeMap = new TreeMap();
      this.nodeFact = null;
      var nodeFact = arguments[0];
      this.nodeFact = nodeFact;
    }
  }]);
  return NodeMap;
}();
export { NodeMap as default };